const purplePalette = {
  main: '#E3D1FF',
  light: '#F7F1FF',
  dark: '#765CC4'
}

export default purplePalette;